import React from "react";

const ManualWaybillTableLoadable = React.lazy(() => import("./ManualWaybillTable"));
const ManualWaybillFormLoadable = React.lazy(() => import("./ManualWaybillForm"));

export {
    ManualWaybillTableLoadable,
    ManualWaybillFormLoadable,
};